// M3.5 — Export Excel modal (PRD R-P0-B4, R-P0-B5)
// - Chỉ yêu cầu TOTP 6 số của admin
// - Gọi /api/questions/export → nhận blob → trigger download
// - Đóng dialog khi xong

import { useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '../lib/api.js';
import { boLabel } from '../lib/bo.js';
import TotpInput from './TotpInput.jsx';

export default function ExportExcelDialog({ open, bo, onClose }) {
  const [totp, setTotp] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  function handleClose() {
    if (submitting) return;
    setTotp('');
    onClose();
  }

  async function doSubmit(codeOverride) {
    const code = (codeOverride ?? totp).trim();
    if (!/^\d{6}$/.test(code)) return toast.error('Mã TOTP phải là 6 chữ số');
    if (submitting) return;
    setSubmitting(true);
    try {
      const { blob, filename } = await api.questionsExport(bo, code);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`Đã tải ${filename}`);
      handleClose();
    } catch (err) {
      toast.error(err?.data?.error || err?.message || 'Export thất bại');
      setSubmitting(false);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    doSubmit();
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="px-5 py-3 border-b flex items-center">
          <h3 className="font-semibold">Export Excel — {boLabel(bo)}</h3>
          <button onClick={handleClose} className="ml-auto text-slate-400 hover:text-slate-800">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div className="text-sm text-slate-600">
            Tải toàn bộ câu hỏi đang active trong bộ <b>{boLabel(bo)}</b> ra file <code>.xlsx</code> gồm 3 cột:
            <span className="mx-1 font-medium">Chủ đề / Câu hỏi / Đáp án</span>.
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Mã TOTP của bạn (6 số)</label>
            <div className="w-40">
              <TotpInput
                value={totp}
                onChange={setTotp}
                onSubmit={(code) => doSubmit(code)}
                autoFocus
                disabled={submitting}
                placeholder="123456"
                testId="export-totp-input"
              />
            </div>
            <div className="text-xs text-slate-500 mt-1">Tự tải khi đủ 6 số</div>
          </div>

          <div className="flex items-center gap-2 pt-2">
            <button type="button" onClick={handleClose} disabled={submitting}
                    className="px-4 py-2 text-sm border rounded hover:bg-slate-50">
              Huỷ
            </button>
            <button type="submit" disabled={submitting}
                    className="px-4 py-2 text-sm bg-slate-800 text-white rounded hover:bg-slate-900 disabled:opacity-50">
              {submitting ? 'Đang tải…' : 'Tải Excel'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
